import React, {
  useState,
  useEffect,
  useRef,
  useMemo,
  useCallback,
} from "react";
import { useDispatch } from "react-redux";
import { patientActions, insuranceActions } from "../../core/actions";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import BtnCellRenderer from "../common/BtnCellRenderer";
import { Grid, TextField, InputLabel, Button } from "@mui/material";
import debounce from "lodash.debounce";
import { el, tr } from "date-fns/locale";
import { set } from "lodash";

function InsuranceProcedureSettlement() {
  const dispatch = useDispatch();
  const [insurancesettle, setInsurancesettle] = useState();
  const [pagination, setPagination] = useState(true);
  const [paginationPageSize, setPaginationPageSize] = useState(10);
  const [recievedAmount, setRecivedAmount] = useState("");
  const [settleclick, setSettleclick] = useState(false);
  const [rowselect, setRowselect] = useState([]);
  const [searchVid, setSearchVid] = useState("");
  const [searchtext, setSearchtext] = useState(false);
  const [companyname, setCompanyName] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [totalamount, setTotalAmount] = useState();
  const [searchValue, setSearchValue] = useState(false);
  const [searchText, setSearchText] = useState(false);
  // const [validate, setValidate] = useState(false);
  const [sedetails, setSedetails] = useState([
    {
      seBankRefno: "",
      seDesc: "",
      seDate: "",
    },
  ]);
  // const [formErrors, setFormErrors]=useState({
  //   seBankRefno: "",
  //   seDate: "",
  //   seDesc: "",
  // })

  const [bankrefErrors, setBankRefErrors] = useState({
    seBankRefno: "",
  });

  const [dateErrors, setDateErrors] = useState({
    seDate: "",
  });

  const [descErrors, setDescErrors] = useState({
    seDesc: "",
  });
  // const context = { componentParent: (props) => handleRendererCall(props) };
  const rowStyle = { background: "white" };
  const onGridReady = (e) => {
    console.log("e:", e.api);
  };
  const getRowHeight = (params) => {
    console.log("params:", params);
    return params.node.data.appTime != "" ? 33 : 35;
  };
  const overlayNoRowsTemplate = "No record found";
  const [columnDefs] = useState([
    {
      headerName: "MAIN",
      field: "patientId",
      headerClass: "ag-header-left",
      valueGetter: (params) => {
        return params.data.patientId;
      },
    },
    {
      headerName: "IP/OP NO",
      field: "ipopnumber",
      headerClass: "ag-header-left",
      valueGetter: (params) => {
        const val = params.data?.ipopnumber;
        return val && val.trim() !== "" ? val : "-";
      },
    },

    {
      headerName: "Name",
      field: "name",
      headerClass: "ag-header-left",
    },
    {
      headerName: "Invoice Number",
      field: "invoiceNum",
      headerClass: "ag-header-left",
      tooltipField: "invoiceNum",
    },
    {
      headerName: "Invoice Date",
      field: "invoiceDatedesc",
      headerClass: "ag-header-left",
      valueFormatter: (params) => {
        console.log("Raw value:", params.value); // <-- for debugging

        if (!params.value) return "";

        return params.value
          .split(",")
          .map((dateStr) => {
            const trimmed = dateStr.trim();
            const date = new Date(trimmed);
            if (isNaN(date)) {
              console.warn("Invalid date:", trimmed);
              return trimmed;
            }

            const options = { month: "short", day: "2-digit", year: "numeric" };
            return date.toLocaleDateString("en-US", options).replace(/,/g, "");
          })
          .join(", ");
      },
      tooltipValueGetter: (params) => {
        if (!params.value) return "";

        return params.value
          .split(",")
          .map((dateStr) => {
            const date = new Date(dateStr.trim());
            if (isNaN(date)) return dateStr;
            return date
              .toLocaleDateString("en-US", {
                month: "short",
                day: "2-digit",
                year: "numeric",
              })
              .replace(/,/g, "");
          })
          .join(", ");
      },
    },

    {
      headerName: "Visit Date",
      field: "visitDate",
      headerClass: "ag-header-left",
      valueFormatter: (params) => {
        if (!params.value) return "";
        const date = new Date(params.value);
        if (isNaN(date)) return "";
        const options = { month: "short", day: "2-digit", year: "numeric" };
        return date.toLocaleDateString("en-US", options); // → "Jul 15, 2025"
      },
    },
    {
      headerName: "Claim Number",
      field: "claimNum",
      headerClass: "ag-header-left",
    },
    {
      headerName: "Claim Request Amount",
      field: "claimRequestAmount",
      headerClass: "ag-header-left",
      cellStyle: { textAlign: "right" },
    },
    {
      headerName: "Claim Approval Amount",
      field: "claimApprovalAmount",
      headerClass: "ag-header-left",
      cellStyle: { textAlign: "right" },
    },
    {
      headerName: "Status",
      field: "status",
      headerClass: "ag-header-left",
    },
  ]);

  const [columnDef] = useState([
    {
      headerName: "Invoice Number",
      field: "invoiceNum",
      headerClass: "ag-header-left",
      checkboxSelection: true,
      headerCheckboxSelection: true,
    },
    {
      headerName: "Claim Number",
      field: "claimNum",
      headerClass: "ag-header-left",
    },
    {
      headerName: "Claim Approval Amount",
      field: "claimApprovalAmount",
      headerClass: "ag-header-left",
      cellStyle: { textAlign: "right" },
    },
    {
      headerName: "Status",
      field: "status",
      headerClass: "ag-header-left",
    },
  ]);

  const defaultColDef = useMemo(() => {
    return {
      editable: true,
      sortable: true,
      flex: 1,
      minWidth: 100,
      filter: true,
      resizable: true,
      floatingFilter: true,
    };
  }, []);

  const [diffAmount, setdiffAmount] = useState("");

  const [settledlist, setSettledlist] = useState([
    {
      id: "",
      patientId: "",
      visitId: "",
      invoiceNum: "",
      type: "",
      seBankRefno: "",
      seDesc: "",
      seDate: "",
      status: "",
      udt: "",
    },
  ]);
  const [list, setList] = useState([]);
  let insurancelocal = "";
  useEffect(() => {
    getInsMaster();
    getSettlementList();
  }, []);

  const didMount = useRef(false);
  useEffect(() => {
    if (!didMount.current) {
      didMount.current = true;
      return;
    }
    console.log("listuseeffect", settledlist);
    if (settledlist && settledlist.length != 0) {
      dispatch(
        patientActions.updateInsuranceProcedure(settledlist, (resCb) => {
          console.log("settlementlist:", settledlist);
          if (resCb.count > 0) {
            console.log("resCb", resCb);

            sedetails.seBankRefno = "";
            sedetails.seDate = "";
            sedetails.seDesc = "";
            setSettleclick(false);
            getSettlementList();
          }
        })
      );
    } else {
      getSettlementList();
    }
  }, [settledlist]);

  const Mount = useRef(false);
  useEffect(
    (name) => {
      if (!Mount.current) {
        Mount.current = true;
        return;
      }
      validateField("seDate");
      validateField("seBankRefno");
      validateField("seDesc");
    },
    [sedetails]
  );

  const getSettlementList = () => {
    let data = {};
    dispatch(
      patientActions.ListInsuranceSettlements(data, (resCb) => {
        console.log("resCb", resCb.insuranceSettlementList);

        if (resCb.insuranceSettlementList) {
          let insurancelocal = resCb.insuranceSettlementList;
          for (let settle of insurancelocal) {
            settle["name"] =
              settle.firstName +
              " " +
              settle.middleName +
              " " +
              settle.lastName;
          }
          setInsurancesettle(insurancelocal);
          setFilteredData(insurancelocal);
          console.log("insurancelocal", insurancelocal);
        }
      })
    );
  };

  const getInsMaster = () => {
    dispatch(
      insuranceActions.getInsuranceMaster((resCb) => {
        if (resCb) {
          console.log("getInsuranceMaster", resCb.masterinsurancelist);

          console.log("response from api : ", resCb);
          let company = [];
          let companylist = resCb.masterinsurancelist;
          if (companylist && companylist != null) {
            for (let comp of companylist) {
              console.log("comp", comp.companyName);

              //   company.push(comp);
              //company.push(comp.id)
              companyname.push(comp);
            }
            console.log("companyname", companyname);
          }
        }
      })
    );
  };

  const settlement = (e) => {
    setSettleclick(true);
  };

  const closeModel = (e) => {
    hadndleReset();
    setSettleclick(false);
    setInsurancesettle([]);
    setFilteredData([]);
    getSettlementList();
  };

  const hadndleReset = () => {
    setInputValue("");
    setSelectedCompany("");
    setdiffAmount("");
    setRecivedAmount("");
    setSearchText(false);
    setSearchValue(false);
    setSearchVid("");
    sedetails.seBankRefno = "";
    sedetails.seDate = "";
    sedetails.seDesc = "";
    setDescErrors({
      seDesc: "",
    });
    setDateErrors({
      seDate: "",
    });
    setBankRefErrors({
      seBankRefno: "",
    });
  };

  const rowSelectionType = "multiple";

  const handleInputChange = (e) => {
    const Recvamnt = Number(e.target.value) || 0; // Ensure it's a valid number
    console.log("Entered Amount:", Recvamnt);
    setRecivedAmount(Recvamnt);
    const difference = Recvamnt - totalamount;
    console.log("difference Amount:", difference);
    setdiffAmount(difference);
  };

  const onSelectionChanged = (e) => {
    console.log("rowselect", e.api.getSelectedRows());
    let settle = e.api.getSelectedRows();
    console.log("settlelength", settle.length);
    setRowselect([...settle]);
    console.log("selectedrows", rowselect);
    let amount = 0;
    let diffamount = 0;
    if (settle) {
      for (let amnt of settle) {
        amount = amount + amnt.amount;
      }
      console.log("totalamount", amount);
      diffamount = recievedAmount - amount;
      console.log("diffamount", diffamount);
      setdiffAmount(diffamount);
      setTotalAmount(amount);
    }
  };

  const handleSubmit = (e) => {
    if (!validateField()) {
      return;
    }

    console.log("selrows:", rowselect);
    let selecteddata = [...rowselect];
    console.log("seldata", selecteddata.length);
    let settledListlocal = [];

    let amount = 0;
    let diffamount = 0;
    if (selecteddata) {
      for (let singlerow of selecteddata) {
        console.log(singlerow);

        let settleditem = {};
        amount = amount + singlerow.amount;
        settleditem["id"] = singlerow.id;
        settleditem["patientId"] = singlerow.patientId;
        settleditem["visitId"] = singlerow.visitId;
        settleditem["invoiceNum"] = singlerow.invoiceNum;
        settleditem["type"] = singlerow.type;
        settleditem["seBankRefno"] = sedetails["seBankRefno"];
        if (settleditem["seBankRefno"] === "") {
          settleditem["status"] = "noc";
        } else {
          settleditem["status"] = "Closed";
        }
        settleditem["seDate"] = sedetails["seDate"];
        settleditem["seDesc"] = sedetails["seDesc"];
        settleditem["udt"] = "";
        settleditem["invoiceDatedesc"] = singlerow.invoiceDatedesc;
        settleditem["claimNum"] = singlerow.claimNum;

        console.log("settleditem", settleditem);

        settledListlocal.push(settleditem);
      }
      console.log("settledlistlocal", settledListlocal);

      setSettledlist([...settledListlocal]);
    }
    console.log("finaldata", settledlist);
  };

  const handleChange = (name, value) => {
    let settlementlocal = { ...sedetails };
    settlementlocal[name] = value;
    setSedetails({ ...settlementlocal });
    console.log("sedetails", sedetails);
  };

  const searchByvisitId = (event) => {
    const value = event.target.value;
    setSearchVid(value);
    const data = { keyword: value };

    if (value.length > 2) {
      setSearchText(true);
      setSearchValue(false);
      setInsurancesettle([]);
      setFilteredData([]);
      debounceSearchSettlement(data);
    } else if (value.length === 0) {
      setSearchValue(false);
      // debounceSearchSettlement(data);
      // Clear data and load full list
      // settlementList();
      debounceSettlementList();
      setSearchText(false);
      setInsurancesettle([]);
      setFilteredData([]);
    } else {
      setSearchText(false);
      setInsurancesettle([]);
      setFilteredData([]);
    }
  };

  const debounceSearchSettlement = useCallback(
    debounce((data) => {
      searchBySettlement(data);
    }, 500),
    []
  );
  const debounceSettlementList = useCallback(
    debounce(() => {
      getSettlementList();
    }, 500),
    []
  );

  const searchBySettlement = (data) => {
    dispatch(
      patientActions.EditInsuranceSettlements(data, (resCb) => {
        const list = resCb?.insuranceSettlementList || [];

        if (data.keyword && data.keyword.length > 2) {
          const enrichedList = list.map((settle) => ({
            ...settle,
            name: `${settle.firstName || ""} ${settle.middleName || ""} ${
              settle.lastName || ""
            }`.trim(),
          }));

          if (!searchValue) {
            setInsurancesettle(enrichedList);

            const filteredList = enrichedList.filter(
              (item) => item.settleStatus?.toLowerCase() !== "closed"
            );
            setFilteredData(filteredList);
          }

          console.log("enrichedList", enrichedList);
        } else {
          setInsurancesettle([]);
          setFilteredData([]);
        }
      })
    );
  };

  // const settlementList = () => {
  //   dispatch(
  //     patientActions.ListInsuranceSettlements({}, (resCb) => {
  //       const list = resCb?.insuranceSettlementList || [];

  //       const enrichedList = list.map((settle) => ({
  //         ...settle,
  //         name: `${settle.firstName || ""} ${settle.middleName || ""} ${
  //           settle.lastName || ""
  //         }`.trim(),
  //       }));

  //       setInsurancesettle(enrichedList);
  //       setFilteredData(enrichedList);

  //       console.log("settlementList", enrichedList);
  //     })
  //   );
  // };

  const validateField = (name) => {
    let fieldValidationErrors = { ...bankrefErrors };
    let dateValidationErrors = { ...dateErrors };
    let descValidationErrors = { ...descErrors };
    let validation = true;

    if (searchtext) {
    } else {
      if (
        (!name && !sedetails["seBankRefno"]) ||
        sedetails["seBankRefno"] === "" ||
        (name == "seBankRefno" && (!sedetails[name] || sedetails[name] === ""))
      ) {
        fieldValidationErrors.seBankRefno = "Please fill BankRef Number";
        validation = false;
        setBankRefErrors(fieldValidationErrors);
      } else if (
        name == "seBankRefno" &&
        (sedetails[name] || sedetails[name] !== "")
      ) {
        fieldValidationErrors.seBankRefno = "";
        setBankRefErrors(fieldValidationErrors);
      }
    }

    if (
      (!name && !sedetails["seDate"]) ||
      sedetails["seDate"] === "" ||
      (name == "seDate" && (!sedetails[name] || sedetails[name] === ""))
    ) {
      dateValidationErrors.seDate = "Please Select Date";
      validation = false;
      setDateErrors(dateValidationErrors);
    } else if (
      name == "seDate" &&
      (sedetails[name] || sedetails[name] !== "")
    ) {
      dateValidationErrors.seDate = "";
      setDateErrors(dateValidationErrors);
    }

    if (
      (!name && !sedetails["seDesc"]) ||
      sedetails["seDesc"] === "" ||
      (name == "seDesc" && (!sedetails[name] || sedetails[name] === ""))
    ) {
      descValidationErrors.seDesc = "Please fill Description";
      validation = false;
      setDescErrors(descValidationErrors);
    } else if (
      name == "seDesc" &&
      (sedetails[name] || sedetails[name] !== "")
    ) {
      descValidationErrors.seDesc = "";
      setDescErrors(descValidationErrors);
    }

    console.log("dateerrors", dateErrors);
    console.log("bankreferrors", bankrefErrors);
    console.log("descerrors", descErrors);
    return validation;
  };

  const handleOnChange = (event) => {
    const value = event.target.value;
    console.log("value", value);

    setSelectedCompany(value);

    // Filter data based on selected value
    if (value) {
      const filtered = insurancesettle.filter((item) => item.iOrg == value);
      setFilteredData(filtered);
    } else {
      setFilteredData(insurancesettle); // Reset to full data when cleared
    }
  };

  const handleFilterInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);

    if (value.length > 2) {
      const filteredData = insurancesettle.filter((row) =>
        row.claimNum?.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredData(filteredData);
    } else {
      setFilteredData(insurancesettle);
    }
  };
  return (
    <>
      <main class="mainsection list-patient">
        <h5 className="text-sm-left mb-0 p-2">Insurance Settlement</h5>
        <form className="main-navbar__search w-100 d-md-flex d-lg-flex p-2">
          <div className="input-group input-group-seamless">
            <div className="input-group-prepend mb-2">
              <span className="input-group-text">
                <i style={{ color: `#111b21` }} className="material-icons">
                  search
                </i>
              </span>
            </div>
            {/* <FormInput
              className="navbar-search mb-2 menu-search bg-white"
              placeholder="Search by visit id to edit settled record..."
              value={searchVid}
              type="number"
              onChange={searchByvisitId}
            /> */}

            <TextField
              id="global-search"
              className="navbar-search mb-2 menu-search bg-white Settlement"
              placeholder="Search Patients By Name / PhoneNumber / MAIN / Claim Number to edit settled record..."
              autoFocus
              value={searchVid}
              // type="number"
              onChange={searchByvisitId}
              InputProps={{
                style: {
                  paddingLeft: "15px",
                  height: "35px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                },
              }}
            />
          </div>
        </form>
        <div className="p-0 preview">
          <div
            className="ag-theme-balham ag-style card rounded table mb-0 tcol option"
            style={{ fontSize: "14px", height: 490, width: `100%` }}
          >
            {/* <AgGridReact
              frameworkComponents={{ BtnCellRenderer: BtnCellRenderer }}
              pagination={pagination}
              paginationPageSize={paginationPageSize}
              rowData={insurancesettle}
              columnDefs={columnDefs}
              defaultColDef={defaultColDef}
              //checkBox={headercheckbox}
              // onRowClicked={(e) => getAggriddata(e)}
            ></AgGridReact> */}
            <AgGridReact
              frameworkComponents={{ BtnCellRenderer: BtnCellRenderer }}
              pagination={pagination}
              paginationPageSize={paginationPageSize}
              // context={context}
              rowData={insurancesettle}
              columnDefs={columnDefs}
              defaultColDef={defaultColDef}
              rowStyle={rowStyle}
              // getRowStyle={getRowStyle}
              // onCellClicked={(e) => {
              //   getAggriddata(e);
              // }}
              onGridReady={onGridReady}
              getRowHeight={getRowHeight}
              overlayNoRowsTemplate={overlayNoRowsTemplate}
            ></AgGridReact>

            <div className="d-flex justify-content-end p-3">
              <button
                id="we"
                className="btn btn-submit btn-primary btn-style bottomright"
                type="submit"
                onClick={(e) => settlement(e)}
                disabled={filteredData.length === 0}
              >
                Settle
              </button>
            </div>
          </div>
        </div>
      </main>
      {settleclick ? (
        <div class="modalmn">
          <div
            className="p-3 preview m-3 flex-column"
            style={{ background: `#fff` }}
          >
            <div>
              {/* Title & Close Button */}
              <div className="d-flex justify-content-between align-items-center mb-1">
                <h5 className="mb-0">Insurance Settlement</h5>
                <span className="cursor-pointer" onClick={closeModel}>
                  X
                </span>
              </div>

              {/* Row for Dropdown and Text Field */}
              <div className="row">
                <div className="col-md-6">
                  <div className="row g-2">
                    {/* Dropdown */}
                    <div className="col">
                      <select
                        className="form-select"
                        aria-label="Select Insurance"
                        value={selectedCompany}
                        onChange={handleOnChange}
                      >
                        <option value="">Select Insurance</option>
                        {companyname.map((company) => (
                          <option key={company.id} value={company.id}>
                            {company.companyName}
                          </option>
                        ))}
                      </select>
                    </div>
                    {/* Text Field */}
                    <div className="col">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Claim Number"
                        value={inputValue}
                        onChange={handleFilterInputChange}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* AG Grid Table */}
            <div className="d-flex flex-column" style={{ height: "80vh" }}>
              {/* AG Grid Table - Responsive Height */}
              <div
                className="ag-theme-balham ag-style card rounded table mt-2 mb-0 tcol"
                style={{ fontSize: "14px", minHeight: "300px" }}
              >
                <AgGridReact
                  frameworkComponents={{ BtnCellRenderer }}
                  pagination={pagination}
                  paginationPageSize={paginationPageSize}
                  rowData={filteredData}
                  columnDefs={columnDef}
                  rowSelection={rowSelectionType}
                  onSelectionChanged={onSelectionChanged}
                  rowMultiSelectWithClick
                  defaultColDef={defaultColDef}
                  rowStyle={rowStyle}
                  onGridReady={onGridReady}
                  getRowHeight={getRowHeight}
                  overlayNoRowsTemplate={overlayNoRowsTemplate}
                />
              </div>

              {/* Form Section */}
              <div className="container-fluid pt-3 px-0">
                <form>
                  {/* Amount Received Date & Received Amount */}
                  <div className="row mb-3">
                    <div className="col-12 col-md-4">
                      <TextField
                        id="AmountReceivedDate"
                        label="Amount Received Date"
                        type="date"
                        value={sedetails.seDate || ""}
                        onChange={(e) => handleChange("seDate", e.target.value)}
                        variant="outlined"
                        error={Boolean(dateErrors.seDate)}
                        helperText={dateErrors.seDate}
                        fullWidth
                        size="small"
                        InputLabelProps={{ shrink: true }} // Ensures label stays above the date
                        InputProps={{ style: { height: "40px" } }} // Optional: Adjust height if needed
                        inputProps={{
                          max: "9999-12-31",
                        }}
                      />
                    </div>
                    <div className="col-12 col-md-4">
                      <TextField
                        id="ReceivedAmount"
                        label="Received Amount"
                        type="number"
                        value={recievedAmount || ""}
                        onChange={handleInputChange}
                        variant="outlined"
                        fullWidth
                        size="small"
                      />
                    </div>
                    <div className="col-12 col-md-4">
                      <TextField
                        id="AmountDifference"
                        label="Amount Difference"
                        type="number"
                        value={diffAmount || 0}
                        onChange={handleInputChange}
                        variant="outlined"
                        fullWidth
                        size="small"
                        InputProps={{
                          readOnly: true,
                        }}
                      />
                    </div>
                  </div>

                  {/* Bank Reference Number & Description */}
                  <div className="row mb-3">
                    <div className="col-12 col-md-4">
                      <TextField
                        id="BankRefNo"
                        label="Bank Reference Number"
                        type="text"
                        required
                        value={sedetails.seBankRefno || ""}
                        onChange={(e) =>
                          handleChange("seBankRefno", e.target.value)
                        }
                        variant="outlined"
                        error={!!bankrefErrors?.seBankRefno}
                        helperText={bankrefErrors?.seBankRefno || ""}
                        fullWidth
                        size="small"
                      />
                    </div>
                    <div className="col-12 col-md-4">
                      <TextField
                        id="Description"
                        label="Description"
                        type="text"
                        value={sedetails.seDesc || ""}
                        onChange={(e) => handleChange("seDesc", e.target.value)}
                        variant="outlined"
                        error={!!descErrors?.seDesc}
                        helperText={descErrors?.seDesc || ""}
                        fullWidth
                        size="small"
                      />
                    </div>
                  </div>

                  {/* Submit Button */}
                  <div className="d-flex justify-content-end">
                    <button
                      className="btn btn-primary btn-style"
                      type="submit"
                      onClick={handleSubmit}
                    >
                      Save
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
}

export default InsuranceProcedureSettlement;
